<template>
  <div id="contenedor-principal-firmas" style="position:relative;">
    <div id="contenedor-encabezados-firmas" class="text-left">
      <h1>Firmas</h1>
      
    </div>
    <div id="contenedor-principal-firmas" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      
      <div v-show="(!mostrarFormularioRecibodeFirma)"  id="contenedor-filtros-firmas" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[ (mostrarFormularioRecibodeFirma)  ? 'wrapDivBloqueado': '']">
       <div v-bind:class="[ (mostrarFormularioRecibodeFirma) ? 'area_verde bloquearDiv': 'area_verde']">

       <!-- <div v-show="!mostrarFormularioEdicionFirma"  id="contenedor-filtros-firmas" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'wrapDivBloqueado': '']">
       <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'area_verde bloquearDiv': 'area_verde']">    -->   
        
        <div >
       
            <FiltroDeBusquedaFirmas 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :AccionesMostrar="comportamientoFiltroDeBusquedaFirmas"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarProcesadoAPI"
                :tituloDeBusqueda="'Búsqueda del procesado a firmar'"
                :tituloDeSeleccione="'Ingrese al menos una de las siguientes entradas:'"              
                :ref="'filtroBusqueda'">
            </FiltroDeBusquedaFirmas>
      
          </div>
        </div>
      
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div v-bind:class="[(mostrarFormularioRecibodeFirma) ? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12':'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0']" id="ProcesadosEncontrados_div">
        <div class="area_verde">
          <transition name="fade">

          <!-- <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0)" style="background-color:var(--gris-pj); padding: 8px;"> -->

          <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0) && (!mostrarFormularioRecibodeFirma)" style="background-color:var(--gris-pj); padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-hand-paper mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Firmas a encontrar</h5>
                <!-- Esto es lo que se muestra antes de la busqueda -->
              </div>
            </div>
          </div>
          <TablaDeResultadosFirmas 
            v-else-if="firmas != undefined && firmas != null"
            v-show="(!mostrarFormularioRecibodeFirma)"
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaFirmas="firmas">
          </TablaDeResultadosFirmas>
          </transition>

          <transition name="fade">
          <RecibodeFirma 
            v-if="mostrarFormularioRecibodeFirma2"          
            :ReciboFirmas="Firma"
            :DireccionUrl="this.urlPagina"
            :tituloDeInformacion="'Recibo de firma'"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            v-on:botoncancelarimprimir="restablecerVistaFirmas"
            :ref="'informacionRecibo'">
          </RecibodeFirma>
          </transition>

          
          

        </div>


        


      </div> 




    </div>
    
  </div>
</template>

<script>
import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
import FiltroDeBusquedaFirmas from '@/components/SIVAC/Comun/FiltroDeBusquedaFirmas'
import RecibodeFirma from '@/components/SIVAC/Firmas/RecibodeFirma'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'




export default {
    components: {
      FiltroDeBusquedaFirmas,
      TablaDeResultadosFirmas,
      RecibodeFirma
    },
    
    data(){
      return{
          enumeraciones,
          tituloDeRecibodeFirma:'',
          mostrarFormularioRecibodeFirma:false,
          mostrarFormularioRecibodeFirma2:false,
          accionesdelaTablaDeResultadosFirmas:{
          alta: true,
          impresion: true,
          cambios: false,
          visualizacion: true,
          altamanual: true,
          bajapersona: false,
          mensaje: false,
          verificarregistro: true,
          output: null,
          mensajeDeAlerta: true,
          mostrarcatalogocompleto: false
        },

        comportamientoFiltroDeBusquedaFirmas:{            
          administracion: true,
          consulta: false,
          mostrarFiltroCompleto: false
        },

        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' }
        ],
        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },
        firmas: null,
        Firma: null,

        urlPagina: "",


      }
    },
    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI:function() 
      { 
        const parametros = 
        {    
                                       
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.firmas.firmasmodulo.BuscarProcesadosParaFirmar, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.$nextTick(()=> { PaginarTabla('tablaDeProcesadosParaFirma_table', 10)});
              // if(this.mensajeDeAlerta!=false){
              //   comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              // }
              // this.mensajeDeAlerta=true;

             
             
              
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },


            /** 
       * Metodo encargado activar la vista para el recibo de la firma.
       */
      generarRecibo:function()
      {
       
       //this.mostrarFormularioRecibodeFirma= true; Muestra la vista previa de la impresión

       this.mostrarFormularioRecibodeFirma2= true;

       this.urlPagina = window.location.origin;

      
      },


      



      validarDatosBusquedaProcesado: function(datos)
      {
        if( (datos.ClaveDelProcesado == null || datos.ClaveDelProcesado == undefined) &&
            (datos.Nombre == null || datos.Nombre == undefined) && 
            (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined) && 
            (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined)
        )
        {          
            comun.mensajeDeAlerta("Favor de llenar por lo menos un campo del formulario.", null, null);
            return false;
        }
        return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },



      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {
        this.limpiarValores();
        //Asignar un id para mostrar los valores en una vista
        this.Firma = Object.assign({}, datos.Firma);

       


        //Generación de una nueva firma, activa componente y proporciona un título
        if(datos.Accion.Alta)
        {
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por generar una nueva firma, si decide continuar se generara la firma para el procesado. <br> <br /> Nota: la ultima firma vigente pasara al reporte de firmas no vigentes <br> <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Generar nueva firma'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                this.GenerarNuevaFirmaAPI();
              }
            }
          });
          
        }

        //Impresión del recibo de la firma
        else if(datos.Accion.Impresion)
        {


          this.generarRecibo();
          
        }
        

        //Generación de firma manual 
        else if(datos.Accion.AltaManual) 
        {
                    
          var locale = {
          OK: '<i class="fa fa-check"></i>&nbsp;&nbsp;OK',
          CONFIRM: '<i class="fa fa-check"></i>&nbsp;&nbsp;Generar nueva firma manual',
          CANCEL: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
          };
            
          bootbox.addLocale('custom', locale);




          bootbox.prompt({
            title: "Mensaje del sistema",
            message: "Está por generar una nueva firma manual sin verificar que checo en el dispositivo, si decide continuar se generara la firma para el Procesado. <br> <br> Nota: esto solo se realiza en casos especiales <br> <br />Ingrese el motivo por el cual se generará la firma sin el dispositivo:",


            locale: 'custom',
            
            
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                // console.log('This was logged in the callback: ' + respuestaContinuar);
                this.GenerarNuevaFirmaManualAPI(respuestaContinuar);
              }
            }
          });
        }


         // Verificar registro con el dispositivo

        else if(datos.Accion.VerificarRegistro)
        {


          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por verificar si el procesado cuenta con un registro de asistencia el dia de hoy. <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                this.VerificarRegistroDispositivoAPI();
              }
            }
          });




          
          



        }















      },


            /** 
       * Metodo encargado de llamar a API para generar una nueva firma con el dispositivo
       */
      GenerarNuevaFirmaManualAPI:function(respuestaContinuar)
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ExpedienteId: this.Firma.ExpedienteId,
          PersonaId: this.Firma.PersonaId,
          ProcesadoId: this.Firma.ProcesadoId,
          ClaveDelProcesado: this.Firma.ClaveDelProcesado,
          Temporalidad: this.Firma.TipoTemporalidadId,
          MensajeProximaFirma: this.Firma.MensajeProximaFirma,
          TipoEstatusMensajeId: this.Firma.TipoEstatusMensajeId,
          TipoEstatusFirmaId: this.Firma.TipoEstatusFirmaId,


          BitacoraMovimientos:{

           
            MotivoMovimiento: respuestaContinuar
            

          }


         // Nota: this.Firma.FirmaId viene de la tabla de resultados  y this.Firma es el objeto//



        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.firmas.firmasmodulo.GenerarNuevaFirmaManual, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();

            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },



            /** 
       * Metodo encargado de llamar a API para generar una nueva firma con el dispositivo
       */
      GenerarNuevaFirmaAPI:function()
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ExpedienteId: this.Firma.ExpedienteId,
          PersonaId: this.Firma.PersonaId,
          ProcesadoId: this.Firma.ProcesadoId,
          ClaveDelProcesado: this.Firma.ClaveDelProcesado,
          Temporalidad: this.Firma.TipoTemporalidadId,
          MensajeProximaFirma: this.Firma.MensajeProximaFirma,
          TipoEstatusMensajeId: this.Firma.TipoEstatusMensajeId,
          TipoEstatusFirmaId: this.Firma.TipoEstatusFirmaId,


         // Nota: this.Firma.FirmaId viene de la tabla de resultados  y this.Firma es el objeto//

         


        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.firmas.firmasmodulo.GenerarNuevaFirma, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();

            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },





          /** 
       * Metodo encargado de llamar a API para generar una nueva firma con el dispositivo
       */
      VerificarRegistroDispositivoAPI:function()
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ExpedienteId: this.Firma.ExpedienteId,
          PersonaId: this.Firma.PersonaId,
          ProcesadoId: this.Firma.ProcesadoId,
          ClaveDelProcesado: this.Firma.ClaveDelProcesado,
          Temporalidad: this.Firma.TipoTemporalidadId,
          MensajeProximaFirma: this.Firma.MensajeProximaFirma,
          TipoEstatusMensajeId: this.Firma.TipoEstatusMensajeId


         // Nota: this.Firma.FirmaId viene de la tabla de resultados  y this.Firma es el objeto//

         


        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.firmas.firmasmodulo.VerificarRegistroDispositivo, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            // this.restablecerValoresDespuesDeGuardarOEliminar();

            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },


















      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        
        this.mostrarFormularioRecibodeFirma2 = false;
        // this.mensajeDeAlerta= false;    
        this.limpiarValores();
        this.limpiarTablaResultados();
        this.buscarProcesadoAPI();

      },


      restablecerVistaFirmas()
      {
       
        this.mostrarFormularioRecibodeFirma2 = false;
        
       

      }











     }
    }

</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/Firmas.vue